export const LockIcon = () => {
  return (
    <i className='material-symbols-lock-outline text-xl m-[2px] bg-[var(--mui-palette-primary-main)]' />
  );
};
